export const principals = Object.freeze({
  ht: 1,
  iskon: 2,
});
